import { Card, Row, Col } from 'antd';
import supplement from '../../assets/Ενημερωτικό ένθετο τηλεματικής συσκευής (Beacon).pdf';

export default function InstallationGuideBeacon() {
  return (
    <Card type="inner">
      <Row justify="center">
        <Col xs={24} lg={12}>
          <a
            href={supplement}
            download="Ενημερωτικό ένθετο τηλεματικής συσκευής (beacon)"
          >
            <Col> Ενημερωτικό ένθετο τηλεματικής συσκευής (beacon)</Col>
          </a>
          <embed src={supplement} width="100%" height="1700px" />
        </Col>
      </Row>
    </Card>
  );
}
